$(document).ready(function () {

    $.fn.slider.Constructor.prototype.disable = function () {
        this.picker.off();
    };
    
    $.fn.slider.Constructor.prototype.enable = function () {
        if (this.touchCapable) {
            // Touch: Bind touch events:
            this.picker.on({
                touchstart: $.proxy(this.mousedown, this)
            });
        } else {
            this.picker.on({
                mousedown: $.proxy(this.mousedown, this)
            });
        }
    };

    $('input:checkbox').iCheck({
        checkboxClass: 'icheckbox_square-yellow',
        radioClass: 'iradio_square-yellow',
        increaseArea: '20%'
    });
    
    $('input:checkbox').on('ifToggled', function() {
        if (this.checked) {
            if($(this).attr('id') === 'checkbox-rent') {
                $('#slider-rent>b').css('opacity','1');
                $('#slider-rent .slider').css('opacity','1');
                $('#price-range-rent').slider('enable');
                $('#slider-rent .sliderrange, #slider-rent .slider-track').css({'cursor': 'pointer'});
                $('#price-range-rent').slider({tooltip: 'show'});
            } else if($(this).attr('id') === 'checkbox-sale') {
                $('#slider-sale>b').css('opacity','1');
                $('#slider-sale .slider').css('opacity','1');
                $('#price-range-sale').slider('enable');
                $('#slider-sale .sliderrange, #slider-sale .slider-track').css({'cursor': 'pointer'});
            }
        } else {
            if($(this).attr('id') === 'checkbox-rent') {
                $('#slider-rent>b').css('opacity','0');
                $('#slider-rent .slider').css('opacity','0.2');
                $('#price-range-rent').slider('disable');
                $('#slider-rent .sliderrange, #slider-rent .slider-track').css({'cursor': 'default'});
            } else if($(this).attr('id') === 'checkbox-sale') {
                $('#slider-sale>b').css('opacity','0');
                $('#slider-sale .slider').css('opacity','0.2');
                $('#price-range-sale').slider('disable');
                $('#slider-sale .sliderrange, #slider-sale .slider-track').css({'cursor': 'default'});
            }
        }
    });
    
    if($('#checkbox-rent').parent().hasClass('checked')) {
        $('#slider-rent>b').css('opacity','1');
        $('#slider-rent .slider').css('opacity','1');
        $('#price-range-rent').slider('enable');
        $('#slider-rent .sliderrange, #slider-rent .slider-track').css({'cursor': 'pointer'});
    } else {
        $('#price-range-rent').slider({tooltip: 'show'});
        $('#slider-rent>b').css('opacity','0');
        $('#slider-rent .slider').css('opacity','0.2');
        $('#price-range-rent').slider('disable');
        $('#slider-rent .sliderrange, #slider-rent .slider-track').css({'cursor': 'default'});
    }
    
    if($('#checkbox-sale').parent().hasClass('checked')) {
        $('#slider-sale>b').css('opacity','1');
        $('#slider-sale .slider').css('opacity','1');
        $('#price-range-sale').slider('enable');
        $('#slider-sale .sliderrange, #slider-sale .slider-track').css({'cursor': 'pointer'});
    } else {
        $('#price-range-sale').slider({tooltip: 'show'});
        $('#slider-sale>b').css('opacity','0');
        $('#slider-sale .slider').css('opacity','0.2');
        $('#price-range-sale').slider('disable');
        $('#slider-sale .sliderrange, #slider-sale .slider-track').css({'cursor': 'default'});
    }
    
    $('#price-range-size').slider();
    
    $('input[value="on"]').iCheck('check');
    $('input[value="on"]').trigger('ifToggled');
        
});